import * as React from 'react'
import {Page} from '@frontrow/console/src/components/ui/page'

import {Routes} from '@frontrow/console/src/routers/routes'

type Props = {
  children: React.ReactNode
}

export default function Wrapper(props: Props): React.ReactElement {
  const {children} = props

  const pageTitle = 'Manage Renaissance Configuration'

  return (
    <Page
      title={pageTitle}
      breadcrumbsAttrs={{
        path: [{url: Routes.schools.schools(), name: 'Schools'}],
        currentItemName: pageTitle
      }}
    >
      {children}
    </Page>
  )
}
